import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { VisitorTracker } from "@/lib/tracker";

import Landing from "@/pages/Landing";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PartnerEnroll from "@/pages/PartnerEnroll";
import PartnerSignup from "@/pages/PartnerSignup";
import FindPartners from "@/pages/FindPartners";
import PaymentResult from "@/pages/PaymentResult";
import DocumentAccess from "@/pages/DocumentAccess";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPartners from "@/pages/admin/AdminPartners";
import AdminFamilies from "@/pages/admin/AdminFamilies";
import AdminStudents from "@/pages/admin/AdminStudents";
import AdminRecords from "@/pages/admin/AdminRecords";
import AdminRecordReview from "@/pages/admin/AdminRecordReview";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminLiveUsers from "@/pages/admin/AdminLiveUsers";
import AdminDropOffs from "@/pages/admin/AdminDropOffs";
import PartnerDashboard from "@/pages/partner/PartnerDashboard";
import PartnerGuide from "@/pages/partner/PartnerGuide";
import PartnerPlan from "@/pages/partner/PartnerPlan";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <VisitorTracker />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/become-a-partner" element={<PartnerSignup />} />
            <Route path="/partners" element={<FindPartners />} />
            <Route path="/login" element={<Navigate to="/partner" replace />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment/success" element={<PaymentResult />} />
            <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
            <Route path="/document/:token" element={<DocumentAccess />} />

            <Route
              path="/admin"
              element={
                <ProtectedRoute role="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/partners"
              element={
                <ProtectedRoute role="admin">
                  <AdminPartners />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/families"
              element={
                <ProtectedRoute role="admin">
                  <AdminFamilies />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/students"
              element={
                <ProtectedRoute role="admin">
                  <AdminStudents />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/records"
              element={
                <ProtectedRoute role="admin">
                  <AdminRecords />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/records/:recordId"
              element={
                <ProtectedRoute role="admin">
                  <AdminRecordReview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/live-users"
              element={
                <ProtectedRoute role="admin">
                  <AdminLiveUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/drop-offs"
              element={
                <ProtectedRoute role="admin">
                  <AdminDropOffs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <ProtectedRoute role="admin">
                  <AdminSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partner"
              element={
                <ProtectedRoute role="partner">
                  <PartnerDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/portal" element={<Navigate to="/partner" replace />} />
            <Route
              path="/partner/plan"
              element={
                <ProtectedRoute role="partner">
                  <PartnerPlan />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partner/how-it-works"
              element={
                <ProtectedRoute role="partner">
                  <PartnerGuide />
                </ProtectedRoute>
              }
            />

            <Route path="/:slug" element={<PartnerEnroll />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
